module.exports = __webpack_public_path__ + "dac86a642240ac07e1355ec69b9d69d4.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/montserrat-regular-webfont.woff
// module id = 981
// module chunks = 0